export const isRenderableChatMessage = (message) =>
  (message?.message_type === "call" && Boolean(message.context_data?.call)) ||
  (typeof message?.content === "string" && message.content.trim().length > 0);

export const parseChatTimestamp = (timestamp) => {
  if (timestamp instanceof Date) {
    return Number.isNaN(timestamp.getTime()) ? null : timestamp;
  }

  if (typeof timestamp !== "string" || !timestamp.trim()) return null;

  const value = timestamp.trim();
  const hasTimezone = /(?:z|[+-]\d{2}:?\d{2})$/i.test(value);
  const date = new Date(hasTimezone ? value : `${value}Z`);

  return Number.isNaN(date.getTime()) ? null : date;
};
